export default __webpack_public_path__ + "static/pet-place-1a56164e56365d97d71ced2bceb6192c.jpg";